export const parseErrorMessage = (error: unknown): string => {
  if (typeof error === 'string') return error;
  if (error instanceof Error) return error.message;
  if (typeof error === 'object' && error !== null) {
    const anyErr = error as any;
    if (anyErr.message) return String(anyErr.message);
    if (anyErr.details) return String(anyErr.details);
    if (anyErr.error_description) return String(anyErr.error_description);
    try { return JSON.stringify(error); } catch { return "An unknown error occurred."; }
  }
  return String(error);
};
